import React from "react";
import { useReveal } from "@/lib/useReveal";
import { Store, Code2, Megaphone, MapPin } from "lucide-react";

const CASES = [
  {
    icon: Store,
    label: "D2C founders",
    hint: "Skincare, apparel, food, home decor",
    outcome: "Find people ranting about the exact category you sell in - often before they hit checkout somewhere else.",
    kw: "\"finally found a good sunscreen for oily skin\"",
  },
  {
    icon: Code2,
    label: "SaaS founders",
    hint: "B2B tools, dev-tools, verticalized SaaS",
    outcome: "Track buying-intent threads on Reddit and LinkedIn. Reply as the founder, not as a bot.",
    kw: "\"looking for an Airtable alternative under 2k\"",
  },
  {
    icon: Megaphone,
    label: "Marketing agencies",
    hint: "Growth, performance, content shops",
    outcome: "Show clients social listening they didn't ask for. Prove market intel weekly - no big enterprise tools.",
    kw: "\"agency in Bangalore for D2C growth\"",
  },
  {
    icon: MapPin,
    label: "Local service businesses",
    hint: "Clinics, coaches, contractors, studios",
    outcome: "Local pain-and-question posts, filtered to your city - micro-lead-gen for the neighborhood.",
    kw: "\"good dentist near Whitefield?\"",
  },
];

export default function UseCases() {
  const [headRef, headVisible] = useReveal();
  const [gridRef, gridVisible] = useReveal(0.15);

  return (
    <section id="use-cases" className="max-w-7xl mx-auto px-5 md:px-10 py-20 md:py-24 lm-cv">
      <div
        ref={headRef}
        className={`max-w-3xl mb-12 lm-reveal ${headVisible ? "is-visible" : ""}`}
      >
        <div className="text-xs font-mono uppercase tracking-widest text-lm-secondary mb-3">
          For whom
        </div>
        <h2 className="text-3xl md:text-5xl font-display font-semibold leading-tight tracking-tight">
          Built for the founders under-served by big sales tools.
        </h2>
      </div>

      <div ref={gridRef} className="grid grid-cols-1 md:grid-cols-2 gap-5 lm-stagger">
        {CASES.map((c, i) => (
          <div
            key={c.label}
            style={{ "--i": i }}
            className={`group bg-lm-surface border border-lm-border rounded-lg p-6 md:p-7 hover:border-lm-primary/40 transition-all lm-reveal ${gridVisible ? "is-visible" : ""}`}
          >
            <div className="flex items-start gap-4">
              <div className="w-11 h-11 rounded-lg bg-lm-tint2 text-lm-primary flex items-center justify-center shrink-0">
                <c.icon className="w-5 h-5" strokeWidth={1.8} />
              </div>
              <div className="flex-1">
                <div className="flex items-baseline gap-3 mb-1">
                  <h3 className="text-lg font-display font-semibold">{c.label}</h3>
                  <span className="text-xs text-lm-text3">{c.hint}</span>
                </div>
                <p className="text-sm text-lm-text2 leading-relaxed">{c.outcome}</p>
                <div className="mt-4 inline-flex items-center gap-2 px-3 py-1.5 rounded-md bg-lm-tint text-xs font-mono text-lm-text2 border border-lm-border">
                  <span className="w-1.5 h-1.5 rounded-full bg-lm-secondary" />
                  Sample buyer signal · {c.kw}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
